import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {FETCH_ADMIN_PRODUCTS,CLEAR_SELECTED_PRODUCTS,DELETE_ADMIN_PRODUCT,
    FETCH_FOCUS_AREAS,
    FETCH_ALL_SELLERS_LIST,} from "actions/actionTypes";
import queryString from 'query-string'
import async  from 'async';
import PaginationBox from'shared/PaginationBox';
import RemoveModalDialog from'shared/RemoveModalDialog';
import PartnerProductListTable from 'partners/products/PartnerProductListTable';
import PartnerProductSearchBox from 'partners/products/PartnerProductSearchBox'
import PartnerProductActionsBox from 'partners/products/PartnerProductActionsBox'

 import config from  '../../../config';

class PartnerProductPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
         this.state = {
            perPage: config.table.numberPerPage,
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) -1,
            selectAllProducts:false,
         };
      };

    componentWillMount() {

        var self = this;

        if (_.size(self.props.allSellersList.data) == 0) {
            var methodData = {
                "success_event": FETCH_ALL_SELLERS_LIST,
                "endpoint": "/sellers",
                'not_display_success_message': true
            };
var SellerGroupID = _.get(this.props.userReducer.user,'CustomData.SellerGroupID','')
            if( !_.isUndefined(this.props.location.query.SellerGroupID)  && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [ 'Administrator'])) > 0){
                SellerGroupID =  this.props.location.query.SellerGroupID
            }
            this.props.makeRequest({sortBy:'DisplayName:1',all:true,
              SellerGroupID:SellerGroupID,
                include:['DisplayName','InventoryOwnership']}, methodData).catch(err => {
            });
        }
    }

    toggleAllProductsSelection(value) {
         if (value) {
            this.setState({ selectAllProducts:true});
        }else{
            this.setState({ selectAllProducts:false});
        }
    }

    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params={}) {
      const self = this;
      if (this.state.pending){
        this.props.displayMessage({
          'messageType': 'warning',
          'messageCode': 'Please wait till search request is completed'
        });
        return Promise.reject(false)
      }
      this.setState({pending:true})
         if (_.isUndefined(params.doNotClearSelectedProducts) && _.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_PRODUCTS)
        }
        var fieldsToOmit = ['include','sortBy','sortByThird', 'sortBySecondary', 'addFields','PickupID', 'CreatedByUserID','lookup', 'all','sortBySecondary']
        if (_.size(_.get(this.refs.actionsBox, 'state.additionalDataFields', []))) {
            this.refs.actionsBox.fetchAdditionalData({})
        }
         var {queryParams} = this.searchBox.getSearchParams();


        if (params.page ==1) {
            params.page = undefined;
        }
        _.extend(queryParams, params);
        if (!_.isUndefined(params.include)  ) {
            queryParams.include = params.include;
        }
         if (_.get(this.props.userReducer.user,'CustomData.SellerGroupID')) {
            queryParams.SellerGroupID = _.get(this.props.userReducer.user, 'CustomData.SellerGroupID')
            fieldsToOmit.push('SellerGroupID')
        }
           if( !_.isUndefined(this.props.location.query.SellerGroupID)  && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [ 'Administrator'])) > 0){
               queryParams.SellerGroupID =  this.props.location.query.SellerGroupID
           }

        if (!_.isUndefined(params.all)  ) {
            queryParams.all = true;
        }

        if (this.state.sortBy) {
                 queryParams.sortBy = this.state.sortBy;
                queryParams.sortBySecondary = '_id:-1';
                /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
            if (_.includes(queryParams.sortBy, 'SKU')){
                var FieldAndSortOption = queryParams.sortBy.split(':');
                queryParams.sortBy ='SellerID.SellerNumber:'+FieldAndSortOption[1]
                queryParams.sortBySecondary = 'PickupID.SellerPickupNumber:'+FieldAndSortOption[1]
                queryParams.sortByThird = 'ProductNumber:'+FieldAndSortOption[1]
             }
         }

        queryParams.lookup = [  'SellerID' ]
      queryParams.addFields = [ 'SoldQuantity',  ]
        var methodData = {
            "endpoint": "/products",
            'not_display_success_message': true
        };
        if (_.isUndefined(params.include)  ) {
            methodData['success_event'] = FETCH_ADMIN_PRODUCTS;
        }

         const stringified = queryString.stringify(_.omit(queryParams,fieldsToOmit));
        delete queryParams.ServiceID /* PickupID is used instead of ServiceID*/
        this.context.router.push('/partner/products?' + stringified);

        return this.props.makeRequest(queryParams, methodData).then(function(response) {
          self.setState({pending:false})
            return  response
        }).catch(err => {
          self.setState({pending:false})
        });
     }
    getAggregatedData(params) {
        return new Promise((resolve, reject) => {
            var self = this
            var functionsToCall = {};
            _.forEach(params.additionalDataFields, function (field, index) {

                functionsToCall[field.value] = function (done) {
                    var {queryParams} = self.searchBox.getSearchParams();
                   queryParams.groupBy = field.value
                    queryParams.all = true;
                    //   queryParams.lookup = ['CreatedByUserID','SellerID','Pickup', 'Transactions']
                    queryParams.addFields = params.totalDataFields
                    var methodData = {
                        "endpoint": "/products",
                        'not_display_success_message': true
                    };
                    delete queryParams.ServiceID
                    return self.props.makeRequest(queryParams, methodData).then(function (res) {
                         done(null, res.data)
                    }).catch(err => {
                         done(err)
                    });
                }
            })
            async.parallel(functionsToCall,
                function (err, results) {
                     if (err) {
                        return reject()
                    }
                     resolve(results)
                })
        })
    }
    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }
    deleteRecord( ) {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            'type': 'delete',
            endpoint: '/products/' + encodeURIComponent(this.state.currentRecord._id),
            messageData: {'#1#': 'Product'},
            messageCode: 'recordDeleted',
            'success_event': DELETE_ADMIN_PRODUCT,
            'success_event_data': { 'productID': this.state.currentRecord._id},
        };

        this.props.makeRequest({  }, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
         });

    }
    render() {
           return (
            <div >
                 <PartnerProductActionsBox
                    ref={'actionsBox'}
                    searchBox={this.searchBox}
                     search={this.search.bind(this)} getAggregatedData={this.getAggregatedData.bind(this)}   {...this.props} ></PartnerProductActionsBox>

                <PartnerProductSearchBox
                  pending={this.state.pending}
                    ref={(searchBox)=> {
                         if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox
                             this.search({})
                        }
                    }}

                                       search={this.search.bind(this)}  selectAllProducts = {this.state.selectAllProducts} toggleAllProductsSelection = {this.toggleAllProductsSelection.bind(this)}   {...this.props} ></PartnerProductSearchBox>

                {this.props.adminProducts.fetched &&
                <div>
                    { this.props.adminProducts.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Products')}</div> :
                        <div className="top20">

                                <PartnerProductListTable onSortChange={this.onSortChange.bind(this)}
                                                       showRemoveDialog={this.showRemoveDialog.bind(this)}
                                                         currentPage={this.state.currentPage}
                                                         total={this.props.adminProducts.total == 'initial' ? 0 : this.props.adminProducts.total}
                                                       search={this.search.bind(this)} {...this.props}  ></PartnerProductListTable>
                            <PaginationBox
                                currentPage={this.state.currentPage}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : undefined}
                                ref={'pagination'}
                                total={this.props.adminProducts.total == 'initial' ? 0 : this.props.adminProducts.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>
                        </div>}
                </div>
                }
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentItemID: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
     return {
        //seller: getSeller(state, props.params.id),
         userReducer: state.userReducer,
        adminProducts: state.adminProducts,
         allSellersList :state.allSellersList
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,dispatchAction,  displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerProductPage);
